import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';

declare var grecaptcha: any;

@Component({
  selector: 'app-recuperar-senha',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['./recuperar-senha.component.css']
})
export class RecuperarSenhaComponent implements OnInit {
  recuperarFrm: recuperarSenhaData = {
    loading: false,
    data: {
      email: '',
      grecaptcharesponse: ''
    }
  };

  constructor(public userService: UserService, private router: Router) { }

  ngOnInit(): void {
    if (typeof grecaptcha !== 'undefined') {
      if (Object.prototype.toString.call(grecaptcha.render) == '[object Function]') {
        grecaptcha.render('captcha_element', {
          'sitekey': environment.siteKeyCaptcha
        });
      }
    }
  }

  recuperarSenha() {
    this.recuperarFrm.data.grecaptcharesponse = (<HTMLInputElement>document.getElementsByName('g-recaptcha-response')[0]!).value;
    this.recuperarFrm.loading = true;
    this.userService.recuperarSenha(this.recuperarFrm.data).subscribe(
      (res: any) => {
        Swal.fire({
          title: 'Sucesso',
          text: 'Uma nova senha foi enviada para seu email',
          icon: 'success',
          heightAuto: false,
          allowOutsideClick: false,
          focusConfirm: false,
          customClass: {
            confirmButton: 'btn-swal'
          },
        }).then(() => {
          this.router.navigate(['/login']);
        });
      },
      (err: any) => {
        switch (err.status) {
          case 400:
            grecaptcha.reset();
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
          case 422:
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
        }
        this.recuperarFrm.loading = false
      },
      () => (this.recuperarFrm.loading = false)
    );
  }

}

export interface recuperarSenhaData {
  loading: boolean;
  data: {
    email: string;
    grecaptcharesponse: string;
  }
}
